import { Box, Typography } from "@mui/material";
import React from "react";
import { formatTime } from "./utils";
import { useZoomPlayerStyles } from "./style";

type TranscriptLine = { start: number; end: number; text: string; speaker: string };

type TranscriptOverlayProps = {
  line: TranscriptLine;
};

export const TranscriptOverlay: React.FC<TranscriptOverlayProps> = ({ line }) => {
  const classes = useZoomPlayerStyles();
  return (
    <Box className={classes.overlayWrapper}>
      <Box className={classes.overlayBox}>
        <Box className={classes.captionRow}>
          <Typography variant="caption" className={classes.captionChip}>
            {line.speaker}
          </Typography>
          <Typography variant="caption" className={classes.captionTime}>
            {formatTime(line.start)}
          </Typography>
        </Box>
        <Typography className={classes.captionText} variant="body2">
          {line.text.replace(/^[^:]+:\s*/, "")}
        </Typography>
      </Box>
    </Box>
  );
};
